<!--begin::Main-->
<div class="app-main flex-column flex-row-fluid" id="kt_app_main">
    <!--begin::Content wrapper-->
    <div class="d-flex flex-column flex-column-fluid">

        <!--begin::Toolbar-->
        <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
            <!--begin::Toolbar container-->
            <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
                <!--begin::Page title-->
                <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                    <!--begin::Title-->
                    <div class="d-flex align-items-center">
                        <h1 class="page-heading"> <svg width="41" height="44" viewBox="0 0 41 44" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <g filter="url(#filter0_d_615_2549)">
                                    <path
                                        d="M15.1976 30.5794C16.2337 29.2326 17.8276 28.4404 19.5013 28.4404H25.7973C26.7537 28.4404 27.6303 28.0443 28.2679 27.4105L36.0782 19.3298C36.3173 19.0922 36.3173 18.6168 36.0782 18.3792C35.8391 18.1415 35.4406 18.0623 35.2016 18.2207L27.8694 22.5779C27.6303 23.7663 26.5943 24.7169 25.3191 24.7169H17.987C17.5885 24.7169 17.19 24.4 17.19 23.9247C17.19 23.5286 17.5885 23.1325 17.987 23.1325H25.3191C25.877 23.1325 26.3552 22.6572 26.3552 22.1026C26.3552 21.5481 25.877 21.0727 25.3191 21.0727H14.1616C12.5676 21.0727 11.0534 21.7857 10.097 22.9741L7.30762 26.3014L14.4803 31.6885L15.1976 30.5794Z"
                                        fill="#265D91" />
                                    <path
                                        d="M14.8784 33.9066L14.1611 33.352L6.27108 27.4104L4.75684 29.3117L13.3641 35.8079L14.8784 33.9066Z"
                                        fill="#265D91" />
                                    <path
                                        d="M9.93705 17.2701H30.8177C31.4552 17.2701 31.9334 16.7948 31.9334 16.161V10.1401C28.108 11.4869 24.2028 12.1999 20.3773 12.1999C16.5519 12.1999 12.6467 11.4869 8.82129 10.1401V16.161C8.82129 16.7948 9.29947 17.2701 9.93705 17.2701Z"
                                        fill="#265D91" />
                                    <path
                                        d="M31.9334 8.15949V4.59451C31.9334 3.96073 31.4552 3.4854 30.8177 3.4854H25.7967V1.10874C25.7967 0.633412 25.3983 0.158081 24.8404 0.158081H15.9143C15.4361 0.158081 14.958 0.55419 14.958 1.10874V3.4854H9.93705C9.29947 3.4854 8.82129 3.96073 8.82129 4.59451V8.15949C16.4722 11.0115 24.2825 11.0115 31.9334 8.15949ZM16.791 1.98018H23.884V3.40618H16.791V1.98018ZM19.1819 6.97116C19.1819 6.25817 19.7398 5.62439 20.3773 5.62439C21.0149 5.62439 21.5728 6.17894 21.5728 6.97116C21.5728 7.68416 21.0149 8.31793 20.3773 8.31793C19.7398 8.31793 19.1819 7.68416 19.1819 6.97116Z"
                                        fill="#265D91" />
                                </g>
                                <defs>
                                    <filter id="filter0_d_615_2549" x="0.756836" y="0.158081" width="39.501"
                                        height="43.6498" filterUnits="userSpaceOnUse"
                                        color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feColorMatrix in="SourceAlpha" type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                        <feOffset dy="4" />
                                        <feGaussianBlur stdDeviation="2" />
                                        <feComposite in2="hardAlpha" operator="out" />
                                        <feColorMatrix type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                        <feBlend mode="normal" in2="BackgroundImageFix"
                                            result="effect1_dropShadow_615_2549" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_615_2549"
                                            result="shape" />
                                    </filter>
                                </defs>
                            </svg>

                            Nos Appels Offres
                        </h1>
                        <!--begin::Menu-->
                    </div>
                    <!--end::Title-->
                    <!--begin::Breadcrumb-->
                    <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                        <!--begin::Item-->
                        <li class="breadcrumb-item text-muted">
                            <a routerLink="/accueil" class="text-muted ">Accueil</a>
                          </li>
                        <!--end::Item-->
                        <!--begin::Item-->
                        <li class="breadcrumb-item">
                            <span class="bg-gray-400 w-5px h-2px"></span>
                        </li>
                        <!--end::Item-->
                        <!--begin::Item-->
                        <li class="breadcrumb-item text-muted"> <a class="text-muted " routerLink="offres-emploi/liste-offres-emploi">Nos offres d’emploi</a></li>
                        <li class="breadcrumb-item">
                            <span class="bg-gray-400 w-5px h-2px"></span>
                        </li>
                        <!--end::Item-->
                        <!--begin::Item-->
                        <li class="breadcrumb-item text-muted">Ajouter Appel Offre</li>
                        <!--end::Item-->
                    </ul>
                    <!--end::Breadcrumb-->
                </div>
                <!--end::Page title-->
                <!--begin::Actions-->

                <!--end::Actions-->
            </div>
            <!--end::Toolbar container-->
        </div>
        <!--end::Toolbar-->

        <!--begin::Content-->

        <div id="kt_app_content" class="app-content flex-column-fluid mb-4">
            <!--begin::Content container-->
            <div id="kt_app_content_container" class="app-container container-fluid">
                <!--begin::Card-->
                <div class=" card content">

                    <!--begin::Card header-->
                    <div class="container">
                        <div class="d-flex flex-wrap header-grid align-items-center">
                            <div class="section_title">
                                <h1 class="section-heading">Ajouter Appel Offre</h1>
                            </div>
                        </div>
                        <form [formGroup]="createform">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-lg-6 tools mb-10">
                                        <input type="text" formControlName="name" id="poste" class="form-control mb-3"
                                            placeholder="Poste *">
                                        <app-feild-error [control]="createform.get('name')"
                                            [controlName]="'name'"></app-feild-error>
                                    </div>
                                    <div class="col-lg-6 tools mb-10">
                                        <input type="number" min="0"
                                        oninput="validity.valid||(value='0');"
                                            formControlName="years_of_experience" id="annee"
                                            placeholder="Années d'experience *" class="form-control mb-3">
                                        <app-feild-error [control]="createform.get('years_of_experience')"
                                            [controlName]="'years_of_experience'"></app-feild-error>

                                    </div>
                                    <div class="col-lg-6 mb-10">
                                        <ng-select formControlName="post_type" [items]="postType" bindLabel="name" bindValue="id" [notFoundText]="'Aucun élément trouvé'"
                                             [placeholder]="'Type de poste'" autoComplete>
                                        </ng-select>

                                 

                                    </div>
                                    <div class="col-lg-6 tools mb-10">
                                        <ng-select placeholder="Type de contrat" data-hide-search="true" name="format"
                                        formControlName="contract_type" class="form-select mb-3" [multiple]="true">
                                        <ng-option *ngFor="let contractType of contractTypesList"
                                            [value]="contractType.id">{{ contractType.name }}</ng-option>
                                    </ng-select>
                                      

                                    </div>
                                    <div class="col-lg-6 tools mb-10">
                                        <div class="combined-input">
                                            <input type="number" min="0" oninput="validity.valid||(value='0');"
                                                formControlName="salary" id="Salaire" class="form-control"
                                                placeholder="Salaire &euro; ">
                                            <div class="euro">
                                                <svg width="11" height="11" viewBox="0 0 11 11" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M5.889 8.739C6.435 8.739 6.91167 8.62633 7.319 8.401C7.735 8.167 8.06 7.82467 8.294 7.374H10.075C9.737 8.24067 9.19533 8.908 8.45 9.376C7.70467 9.844 6.851 10.078 5.889 10.078C4.875 10.078 3.97367 9.805 3.185 9.259C2.39633 8.70433 1.846 7.96767 1.534 7.049H0.338V6.035H1.3C1.28267 5.79233 1.274 5.60167 1.274 5.463C1.274 5.32433 1.28267 5.13367 1.3 4.891H0.338V3.877H1.534C1.846 2.95833 2.39633 2.226 3.185 1.68C3.97367 1.12533 4.875 0.847999 5.889 0.847999C6.84233 0.847999 7.69167 1.08633 8.437 1.563C9.191 2.031 9.737 2.69833 10.075 3.565H8.294C8.06 3.11433 7.735 2.77633 7.319 2.551C6.91167 2.317 6.435 2.2 5.889 2.2C5.25633 2.2 4.69733 2.34733 4.212 2.642C3.73533 2.93667 3.37133 3.34833 3.12 3.877H5.889V4.891H2.834C2.808 5.073 2.795 5.26367 2.795 5.463C2.795 5.66233 2.808 5.853 2.834 6.035H5.889V7.049H3.12C3.37133 7.58633 3.73533 8.00233 4.212 8.297C4.69733 8.59167 5.25633 8.739 5.889 8.739Z"
                                                        fill="#4B4B4B" />
                                                </svg>

                                            </div>
                                        </div>
                                     

                                    </div>

                                    <div class="col-lg-6 tools mb-10">
                                        <div class="combined-input">
                                            <input type="number" min="0" oninput="validity.valid||(value='0');"
                                                formControlName="tjm" id="TJM" class="form-control "
                                                placeholder="TJM &euro; ">
                                            <div class="euro">
                                                <svg width="11" height="11" viewBox="0 0 11 11" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M5.889 8.739C6.435 8.739 6.91167 8.62633 7.319 8.401C7.735 8.167 8.06 7.82467 8.294 7.374H10.075C9.737 8.24067 9.19533 8.908 8.45 9.376C7.70467 9.844 6.851 10.078 5.889 10.078C4.875 10.078 3.97367 9.805 3.185 9.259C2.39633 8.70433 1.846 7.96767 1.534 7.049H0.338V6.035H1.3C1.28267 5.79233 1.274 5.60167 1.274 5.463C1.274 5.32433 1.28267 5.13367 1.3 4.891H0.338V3.877H1.534C1.846 2.95833 2.39633 2.226 3.185 1.68C3.97367 1.12533 4.875 0.847999 5.889 0.847999C6.84233 0.847999 7.69167 1.08633 8.437 1.563C9.191 2.031 9.737 2.69833 10.075 3.565H8.294C8.06 3.11433 7.735 2.77633 7.319 2.551C6.91167 2.317 6.435 2.2 5.889 2.2C5.25633 2.2 4.69733 2.34733 4.212 2.642C3.73533 2.93667 3.37133 3.34833 3.12 3.877H5.889V4.891H2.834C2.808 5.073 2.795 5.26367 2.795 5.463C2.795 5.66233 2.808 5.853 2.834 6.035H5.889V7.049H3.12C3.37133 7.58633 3.73533 8.00233 4.212 8.297C4.69733 8.59167 5.25633 8.739 5.889 8.739Z"
                                                        fill="#4B4B4B" />
                                                </svg>

                                            </div>
                                        </div>
                                    


                                    </div>

                                    <div class="col-lg-6 tools mb-10">
                                       
                                        <ng-select (change)="onCountryChangeSearch($event)" [items]="paysList" [multiple]="true"
                                        id="pays_destinataire" bindLabel="name" bindValue="name" [placeholder]="'Pays *'"
                                        autoComplete formControlName="country"  [notFoundText]="'Aucun élément trouvé'" >
                                        <ng-template ng-optgroup-tmp let-item="item">
                                          {{ item.name || "Unnamed group" }}
                                        </ng-template>
                                      </ng-select>
                                        <app-feild-error [control]="createform.get('country')"
                                            [controlName]="'country '"></app-feild-error>


                                    </div>
                                    <div class="col-lg-6 tools mb-10">
                                        <!-- <ng-select [items]="stateList" formControlName="city" bindLabel="name" 
                                            bindValue="name" [placeholder]="'Ville *'" autoComplete  [notFoundText]="'Aucun élément trouvé'">
                                        </ng-select> -->
                                        <ng-select  [items]="stateList" [ngClass]="{'disable-select':!stateList?.length}" [attr.disabled]="!stateList?.length ? true : null" [multiple]="true"
                                        (change)="onMobilityChange('add')" id="mobilite" bindLabel="name"
                                        formControlName="city" 
                                        [notFoundText]="'Aucun élément trouvé'" bindValue="name" [placeholder]="'Ville '" autoComplete>
                                        </ng-select>
                                        <app-feild-error [control]="createform.get('city')"
                                            [controlName]="'city'"></app-feild-error>
                                    </div>


                                    <div class="col-lg-6 mb-10">
                                        <div class="form-check form-check-custom form-check-solid">
                                            <input class="form-check-input" formControlName="profile_abroad"
                                                type="checkbox" value="" id="flexCheckChecked" checked />
                                            <label class="form-check-label" for="flexCheckChecked">
                                                Possibilité profil à étranger ( intégration)
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 mb-10">
                                        <div class="form-check form-check-custom form-check-solid" *ngIf="showPasseportTalent" >
                                            <input class="form-check-input" type="checkbox" value=""
                                                formControlName="passeport_talent" id="flexCheckChecked1" checked />
                                            <label class="form-check-label" for="flexCheckChecked1">
                                                Passeport talent
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 tools mb-10">
                                        <div class="mb-10">
                                            <ng-select [items]="skillsList" bindLabel="name_FR" formControlName="skills"  [notFoundText]="'Aucun élément trouvé'"
                                            class="form-select mb-3" placeholder="Compétences" 
                                            [multiple]="true">
                                        </ng-select>
                                            <app-feild-error [control]="createform.get('skills')"
                                                [controlName]="'skills'"></app-feild-error>
                                        </div>
                                        <div class="mb-10">
                                            <input type="text" id="autre" class="form-control mb-3"
                                                placeholder="Autres Compétences" fonormControlName="otherSkills">
                                        </div>
                                    </div>

                                    <div class="col-lg-6 tools mb-10">
                                        <ng-select [items]="disponibilite" formControlName="availability"  [notFoundText]="'Aucun élément trouvé'"
                                            bindLabel="name" bindValue="id" [placeholder]="'Disponibilité'"
                                            autoComplete>
                                        </ng-select>
                                        <app-feild-error [control]="createform.get('availability')"
                                            [controlName]="'availability'"></app-feild-error>

                                    </div>



                                </div>
                                <div class="row">
                                   
                                    <div class="desc tools mb-10">
                                        <!-- <textarea formControlName="description" id="desc" placeholder="Description *"
                                            style="height:150px" class="form-control"></textarea> -->
                                            <quill-editor  [placeholder]="'Description *'" formControlName="description" [modules]="{ toolbar: toolbarOptions }" style="width: 100%; height: 300px;"
                                            (onContentChanged)="onContentChange($event)"
                                            ></quill-editor>  

                                        <app-feild-error [control]="createform.get('description')" 
                                            [controlName]="'description'"></app-feild-error>
                                    </div>
                                </div>
                                <br>
                                <br>
                                <div class="form-check form-check-custom form-check-solid">
                                    <input class="form-check-input ml-2" formControlName="dedicated_to" type="checkbox"
                                    id="flexCheckDefault2" checked [disabled]="true"/>
                                    <label class="form-check-label ml-2" for="flexCheckDefault2">Dédié aux ESN</label>
                              
                                    &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                    <input class="form-check-input"  type="checkbox"
                                        id="flexCheckDefault"  [disabled]="true"/>
                                    <label class="form-check-label" for="flexCheckDefault">Dédié au particulier</label>
                                </div>
                                <div class="row">
                                    <div class="add mt-10">
                                      
                                        <button  class="confirmer"   (click)="ajoutProfilecalloffer()">
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path
                                             d="M11.4758 18.5502L8.44445 10.1374C8.3936 9.99568 8.3859 9.84199 8.42233 9.69585C8.45877 9.54972 8.53768 9.41773 8.64906 9.31666L10.4224 7.53834C10.4123 7.30564 10.4731 7.07538 10.5967 6.87816C10.7203 6.68093 10.9008 6.52609 11.1142 6.43421C11.3276 6.34232 11.5639 6.31775 11.7916 6.36374C12.0193 6.40974 12.2276 6.52413 12.389 6.69171C12.5503 6.8593 12.6569 7.07214 12.6947 7.30196C12.7325 7.53178 12.6997 7.76769 12.6006 7.97835C12.5014 8.189 12.3408 8.36443 12.1398 8.48131C11.9389 8.59819 11.7073 8.65099 11.4758 8.6327L10.0359 10.0766L12.173 16.012L17.0382 1.9754L3.04112 6.85438L6.26948 7.99432C6.46242 8.06588 6.61913 8.21136 6.70511 8.39878C6.79109 8.58619 6.79931 8.80019 6.72796 8.99368C6.65661 9.18717 6.51153 9.34432 6.32465 9.43054C6.13776 9.51677 5.92437 9.52501 5.73142 9.45346L0.509966 7.56114C0.36106 7.50946 0.231921 7.41252 0.140519 7.2838C0.049118 7.15508 0 7.00099 0 6.84298C0 6.68496 0.049118 6.53087 0.140519 6.40216C0.231921 6.27344 0.36106 6.17649 0.509966 6.12481L18.0007 0.0450919C18.136 -0.00387194 18.2825 -0.013182 18.4229 0.0182501C18.5634 0.0496822 18.692 0.120557 18.7937 0.222589C18.8955 0.32462 18.9661 0.45359 18.9975 0.594419C19.0288 0.735247 19.0195 0.882115 18.9707 1.01785L12.9081 18.5578C12.8557 18.7069 12.7584 18.8359 12.6296 18.9269C12.5007 19.0179 12.3468 19.0663 12.1892 19.0655C12.0316 19.0646 11.8782 19.0146 11.7504 18.9222C11.6225 18.8299 11.5265 18.6998 11.4758 18.5502Z"
                                             fill="white" />
                                            </svg>
                                              Publier
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <!--end::Card header-->
                    <!--begin::Card body-->

                    <!--end::Card body-->
                </div>
                <!--end::Card-->
                <!--begin::Modals-->
                <!--begin::Modal - Customers - Add-->

                <!--end::Modal - Customers - Add-->
                <!--begin::Modal - Adjust Balance-->

                <!--end::Modal - New Card-->
                <!--end::Modals-->
            </div>
            <!--end::Content container-->
        </div>
        <!--end::Content-->
    </div>
    <!--end::Content wrapper-->
    <!--end:::Main-->
</div>
